export default __webpack_public_path__ + "static/media/flag-romania.8b892c75.svg";